import { type SVGProps } from 'react'
import { cn } from '@/lib/utils'

export function Logo({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      id='yuandian-engine-logo'
      viewBox='0 0 300 300'
      xmlns='http://www.w3.org/2000/svg'
      fill='currentColor'
      className={cn('size-6', className)}
      {...props}
    >
      <title>元点引擎</title>
      <g>
        <path d='M60.04,76.3c4.15,7.17,8.23,14.19,12.28,21.22,7.88,13.64,15.75,27.28,23.63,40.92q1.56,2.71-1.55,2.72c-4.82,0-9.63.08-14.45-.04-2.06-.05-2.7.46-2.51,2.67,2.51,29.39,24.16,54.74,53.11,61.3,24.94,5.65,46.75-.75,65.27-18.37.7-.66,1.4-1.32,2.05-2.03.85-.93,1.38-.69,1.96.32,5.8,10.09,11.61,20.17,17.47,30.22.81,1.4-.22,1.88-.97,2.53-13.01,11.26-27.85,19.04-44.6,22.99-43.48,10.27-87.89-6.15-112.54-43.34-24.9-37.55-25.17-76.59-2.83-115.72,1.03-1.8,1.99-3.68,3.67-5.38Z' />
        <path d='M233.4,198.79c-4.08-7.05-8.07-13.92-12.05-20.8-7.97-13.79-15.93-27.59-23.89-41.39q-1.53-2.65,1.62-2.67c4.9,0,9.81-.07,14.71.02,1.89.04,2.35-.59,2.2-2.46-2.55-32.76-29.63-60.21-62.25-63.09-22.25-1.96-41.17,5.1-56.97,20.78-2.34,2.32-2.36,2.33-4.04-.56-5.3-9.17-10.55-18.37-15.92-27.49-1.01-1.72-1.04-2.69.59-4.12,32.93-28.72,82.13-33.97,120.29-12.6,27.44,15.37,45.22,38.38,52.38,68.98,7.05,30.1,1.43,58.2-15.54,84.03-.28.42-.65.78-1.15,1.37Z' />
        <circle cx='146.69' cy='138.87' r='39.79' />
      </g>
    </svg>
  )
}
